import React from 'react';
export var LoveMeterContext = React.createContext({
    onLoveChanging: function () { return null; },
    onLoveChanged: function () { return null; },
    onBeforeLoving: function () { return null; },
    onIconClick: function () { return null; },
    onCancelLoving: function () { return null; },
    hasLoveChanged: false,
    hasLoved: false,
    isLoveInProgress: false,
    justLoved: false,
});
//# sourceMappingURL=LoveContext.js.map